"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutText = void 0;
var alignment_1 = require("../alignment");
var fit_text_1 = require("./fit-text");
var layoutText = function (_a) {
    var text = _a.text, horizontalAlignment = _a.horizontalAlignment, verticalAlignment = _a.verticalAlignment, lineSpacing = _a.lineSpacing, maxFontSize = _a.maxFontSize, width = _a.width, height = _a.height, measureTextWidth = _a.measureTextWidth, measureTextHeight = _a.measureTextHeight;
    var fitResult = (0, fit_text_1.fitText)({
        maxFontSize: maxFontSize,
        lineSpacing: lineSpacing,
        measureTextHeight: measureTextHeight,
        measureTextWidth: measureTextWidth,
        text: text,
        width: width,
        height: height,
    });
    var fragments = (0, alignment_1.alignParagraphs)({
        width: width,
        height: height,
        verticalAlignment: verticalAlignment,
        paragraphs: fitResult.paragraphs,
        lineHeight: fitResult.lineHeight,
        horizontalAlignment: horizontalAlignment,
        measureTextWidth: function (text) {
            return measureTextWidth({ text: text, fontSize: fitResult.fontSize });
        },
    });
    return {
        fragments: fragments,
        fontSize: fitResult.fontSize,
        maxFontSize: 0,
        lineHeight: fitResult.lineHeight,
        lineOffsetY: fitResult.lineHeight,
    };
};
exports.layoutText = layoutText;
